export default `query cart($cartId: String!){
  cart(cart_id: $cartId) {
    email
    id
    is_virtual
    total_quantity
    shipping_addresses {
      available_shipping_methods {
        available
        carrier_code
        carrier_title
        error_message
        method_code
        method_title
        amount {
          currency
          value
        }
      }
      selected_shipping_method {
        carrier_code
        carrier_title
        method_code
        method_title
        amount {
          currency
          value
        }
      }
      city
      company
      customer_notes
      firstname
      items_weight
      lastname
      pickup_location_code
      postcode
      street
      telephone
      region {
        code
        label
        region_id
      }
      country {
        code
        label
      }
      extension_attributes {
        ward
        ward_name
        warehouse_code
        type_address
        customer_tax_code
        customer_tax_info
        channel
        order_comment
      }
    }
    applied_coupons {
      code
    }
    items {
      id
      quantity
      uid
      product {
          uid
          __typename
          type_id
          sku
          name
          stock_status
          only_x_left_in_stock
          rating_summary
          thumbnail {
            url
            position
            disabled
            label
          }
          url_key
          url_rewrites {
            url
          }
          price_range {
            maximum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
            minimum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
          }
          categories {
            uid
            name
            url_suffix
            url_path
            breadcrumbs {
              category_name,
              category_url_path
            }
          }
          review_count
          reviews {
            items {
              average_rating
              ratings_breakdown {
                name
                value
              }
            }
          }
        }
      prices {
        price {
          value
        }
        row_total {
          value
        }
        row_total_including_tax {
          value
        }
        total_item_discount {
          value
        }
      }
    }
    extension_attributes {
        free_gift_rule_ids
        free_gift_total
        category_buy_more,
        free_ship
        gift_category_check
        gift_message
        max_qty_check
        min_qty_check
        gift_config {
            max_qty
            rule_id
            total
        }
        coupon_code_odoo
        td_loyalty
        total_freegift
        total_shipping
    }  
     available_payment_methods {
      code
      title
    }
    selected_payment_method {
      code
      purchase_order_number
      title
    }
    prices {
      discounts {
        label
        amount {
          value
        }
      }
      loyalty_discount {
        label
        amount {
          currency
          value
        }
      }
      grand_total {
        value
      }
      subtotal_excluding_tax {
        value
      }
      subtotal_including_tax {
        value
      }
      subtotal_with_discount_excluding_tax {
        value
      }
    }
    billing_address {
      firstname
      lastname
      street
      city
      company
      region {
        code
        region_id
        label
        }
      postcode
      telephone
      country {
        code
        label
      }    
    }
  }
}
`